import { zodResolver } from "@hookform/resolvers/zod";
import { useSupabaseClient, useUser } from "@supabase/auth-helpers-react";
import Input from "components/Input";
import Metadata from "components/Metadata";
import React from "react";
import { useForm, useFormState } from "react-hook-form";
import { toast } from "react-toastify";
import { CURRENT_DOMAIN } from "utils/constants";
import { Routes } from "utils/routes";
import { z } from "zod";

const DataSchema = z.object({
  email: z.string().email(),
});

type Data = z.infer<typeof DataSchema>;

const redirectTo = `${CURRENT_DOMAIN}${Routes.UPDATE_PASSWORD}`;

export default function ResetPasswordPage() {
  const supabase = useSupabaseClient();
  const user = useUser();

  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm<Data>({
    resolver: zodResolver(DataSchema),
    defaultValues: { email: user?.email },
  });

  const onSubmit = async (data: Data) => {
    const res = await supabase.auth.resetPasswordForEmail(data.email, {
      redirectTo,
    });

    if (res.error) {
      toast.error(res.error.message);
    } else {
      reset();
      toast.success(
        "Password reset! Check your email for the link to set your new password."
      );
    }
  };

  return (
    <div className="mx-auto flex w-full max-w-lg flex-1 flex-col items-center justify-center px-4">
      <Metadata
        title="Reset Your Password | Pipers For Hire"
        description="Reset your Pipers For Hire password."
        url="https://pipersforhire.com/reset-password"
      />
      <h1 className="text-2xl font-bold text-theme-blue">Update Password</h1>
      <form onSubmit={handleSubmit(onSubmit)} className="mt-6 w-full">
        <label htmlFor="email" className="block">
          Email
        </label>
        <Input
          {...register("email")}
          className="w-full"
          error={errors.email?.message}
          type="email"
        />
        <button
          type="submit"
          className="mt-4 w-full rounded bg-theme-blue px-4 py-3 text-white"
        >
          Reset Password
        </button>
      </form>
    </div>
  );
}
